import { createRouter, createWebHashHistory } from "vue-router"
import { useAuth } from "../composition-api/useAuth"

import Home from "../views/Home.vue"
import Production from "../views/Production.vue"

import ServiceOrders from "../views/ServiceOrders.vue"
import ProductionOrder from "../views/ProductionOrder.vue"
import ProductionOrderBarcode from "../views/ProductionOrderBarcode.vue"
import Projects from "../views/Projects.vue"
import ServiceOrder from "../views/ServiceOrder.vue"

import InternalOrder from "../views/InternalOrder.vue"
import ProjectEdit from "../views/ProjectEdit.vue"
import LeakageCheckForm from "../views/LeakageCheckForm.vue"
import SignOrder from "../views/SignOrder.vue"
import Workers from "../views/Workers.vue"
import WorkerEdit from "../views/WorkerEdit.vue"
import Customers from "../views/Customers.vue"
import CustomerEdit from "../views/CustomerEdit.vue"

import Users from "../views/Users.vue"
import UserEdit from "../views/UserEdit.vue"

import Warehouses from "../views/Warehouses.vue"
import WarehouseEdit from "../views/WarehouseEdit.vue"
import Offers from "../views/Offers.vue"
import OfferEdit from "../views/OfferEdit.vue"
import Materials from "../views/Materials.vue"
import MaterialEdit from "../views/MaterialEdit.vue"
import WarehouseTransfers from "../views/WarehouseTransfers.vue"
import WarehouseTransferEdit from "../views/WarehouseTransferEdit.vue"

import BomTemplates from "../views/BomTemplates.vue"
import BomTemplateEdit from "../views/BomTemplateEdit.vue"

import FacilityServiceOrders from "../views/FacilityServiceOrders.vue"
import Facilities from "../views/Facilities.vue"
import FacilityEdit from "../views/FacilityEdit.vue"
import Devices from "../views/Devices.vue"
import DeviceEdit from "../views/DeviceEdit.vue"
import DeviceBarcode from "../views/DeviceBarcode.vue"
import ServiceOrdersMap from "../views/ServiceOrdersMap.vue"
import Commissions from "../views/Commissions.vue"
import Calls from "../views/Calls.vue"
import CallEdit from "../views/CallEdit.vue"
import ServiceOrdersWithCompletedMovementsCard from "../components/ServiceOrdersWithCompletedMovementsCard.vue"
import CalibrationReport from "../views/CalibrationReport.vue"
import Checklist from "scripts/views/Checklist.vue"
import ServiceOrderCustomer from "scripts/views/ServiceOrderCustomer.vue"
import Calendar from "scripts/views/Calendar.vue"

const routes = [
  {
    path: "/:keepMessages?",
    name: "Home",
    component: Home,
  },
  {
    path: "/commissions",
    name: "Commissions",
    component: Commissions,
    meta: { requiresAuth: true },
  },
  {
    path: "/calls",
    name: "Calls",
    component: Calls,
    meta: { requiresAuth: true },
  },
  {
    path: "/calls/:callId",
    name: "CallEdit",
    component: CallEdit,
    meta: { requiresAuth: true },
  },
  {
    path: "/calendar",
    name: "Calendar",
    component: Calendar,
    meta: { requiresAuth: true },
  },
  {
    path: "/production",
    name: "Production",
    component: Production,
    meta: { requiresAuth: true },
  },
  {
    path: "/production/order-barcode/:workOrderId",
    name: "ProductionOrderBarcode",
    component: ProductionOrderBarcode,
    meta: { requiresAuth: true },
  },
  {
    path: "/production/order/:workOrderId/:keepMessages?",
    name: "ProductionOrder",
    component: ProductionOrder,
    meta: { requiresAuth: true },
  },
  {
    path: "/service/:keepMessages?",
    name: "Service",
    component: ServiceOrders,
    meta: { requiresAuth: true },
  },
  {
    path: "/servicemap",
    name: "ServiceOrdersMap",
    component: ServiceOrdersMap,
    meta: { requiresAuth: true },
  },
  {
    path: "/service/order/:workOrderId/:keepMessages?/:facilityID?/:customerID?/:projectID?",
    name: "ServiceOrder",
    component: ServiceOrder,
    meta: { requiresAuth: true },
  },
  {
    path: "/servicecustomer/:workOrderId",
    name: "ServiceOrderCustomer",
    component: ServiceOrderCustomer,
    meta: { requiresAuth: true },
  },
  {
    path: "/service/order-leakage-check/:workOrderId/:leakageCheckFormId/:keepMessages?",
    name: "ServiceOrderLeakageCheckForm",
    component: LeakageCheckForm,
    meta: { requiresAuth: true },
  },
  {
    path: "/service/order-calibration-report/:workOrderId/:deviceId/:keepMessages?",
    name: "CalibrationReport",
    component: CalibrationReport,
    meta: { requiresAuth: true },
  },
  {
    path: "/service/order-checklist/:workOrderId/:deviceId/:keepMessages?",
    name: "Checklist",
    component: Checklist,
    meta: { requiresAuth: true },
  },
  {
    path: "/service/order-facility/:workOrderId/:keepMessages?",
    name: "FacilityServiceOrders",
    component: FacilityServiceOrders,
    meta: { requiresAuth: false },
  },
  {
    path: "/service/order-facility-no/:workOrderId/:keepMessages?",
    name: "FacilityServiceOrdersNoSign",
    props: { noSign: true },
    component: FacilityServiceOrders,
    meta: { requiresAuth: false },
  },
  {
    path: "/service/order-sign/:workOrderId",
    name: "SignOrder",
    component: SignOrder,
    meta: { requiresAuth: false },
  },
  {
    path: "/offer",
    name: "Offers",
    component: Offers,
    meta: { requiresAuth: true },
  },
  {
    path: "/offer/:offerId",
    name: "OfferEdit",
    component: OfferEdit,
    meta: { requiresAuth: true },
  },
  {
    path: "/projects",
    name: "Projects",
    component: Projects,
    meta: { requiresAuth: true },
  },
  {
    path: "/projects/:projectId/:productionOrderId?/:keepMessages?",
    name: "Project",
    component: ProjectEdit,
    meta: { requiresAuth: true },
  },
  {
    path: "/internal/order/:workOrderId/:keepMessages?",
    name: "InternalOrder",
    component: InternalOrder,
    meta: { requiresAuth: true },
  },
  {
    path: "/workers",
    name: "Workers",
    component: Workers,
    meta: { requiresAuth: true },
  },
  {
    path: "/workers/:workerId",
    name: "WorkerEdit",
    component: WorkerEdit,
    meta: { requiresAuth: true },
  },
  {
    path: "/customers",
    name: "Customers",
    component: Customers,
    meta: { requiresAuth: true },
  },
  {
    path: "/customers/:customerId",
    name: "CustomerEdit",
    component: CustomerEdit,
    meta: { requiresAuth: true },
  },
  {
    path: "/users",
    name: "Users",
    component: Users,
    meta: { requiresAuth: true },
  },
  {
    path: "/users/:userId",
    name: "UserEdit",
    component: UserEdit,
    meta: { requiresAuth: true },
  },
  {
    path: "/warehouses",
    name: "Warehouses",
    component: Warehouses,
    meta: { requiresAuth: true },
  },
  {
    path: "/warehouses/:id",
    name: "WarehouseEdit",
    component: WarehouseEdit,
    meta: { requiresAuth: true },
  },
  {
    path: "/bom-templates",
    name: "BomTemplates",
    component: BomTemplates,
    meta: { requiresAuth: true },
  },
  {
    path: "/bom-templates/:id",
    name: "BomTemplateEdit",
    component: BomTemplateEdit,
    meta: { requiresAuth: true },
  },
  {
    path: "/materials",
    name: "Materials",
    component: Materials,
    meta: { requiresAuth: true },
  },
  {
    path: "/materials/:id",
    name: "MaterialEdit",
    component: MaterialEdit,
    meta: { requiresAuth: true },
  },
  {
    path: "/warehouse-transfer/:type/:id/:keepMessages?",
    name: "WarehouseTransferEdit",
    component: WarehouseTransferEdit,
    meta: { requiresAuth: true },
  },
  {
    path: "/warehouse-transfer/:keepMessages?",
    name: "WarehouseTransfers",
    component: WarehouseTransfers,
    meta: { requiresAuth: true },
  },
  {
    path: "/facilities",
    name: "Facilities",
    component: Facilities,
    meta: { requiresAuth: true },
  },
  {
    path: "/service-orders-with-completed-movements",
    name: "ServiceOrdersWithCompletedMovementsCard",
    component: ServiceOrdersWithCompletedMovementsCard,
    meta: { requiresAuth: true },
  },
  {
    path: "/facilities/:facilityId",
    name: "FacilityEdit",
    component: FacilityEdit,
    meta: { requiresAuth: true },
  },
  {
    path: "/devices",
    name: "Devices",
    component: Devices,
    meta: { requiresAuth: true },
  },
  {
    path: "/devices/:deviceId/:customerId?/:facilityId?",
    name: "DeviceEdit",
    component: DeviceEdit,
    meta: { requiresAuth: true },
  },
  {
    path: "/devices/:deviceId/barcode",
    name: "DeviceBarcode",
    component: DeviceBarcode,
    meta: { requiresAuth: true },
  },
  {
    path: "/test",
    name: "Test",
    component: {
      template: '<button class="btn" @click="test">Test error.</button>',
      setup() {
        const test = () => {
          throw "Error"
        }
        return { test }
      },
    },
  },
  {
    path: "/failed",
    name: "Failed",
    component: { template: "<h6>Login Failed.</h6>" },
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

/* Add debug logging for router resolution
const originalResolve = router.resolve
router.resolve = function (to, currentLocation) {
  try {
    console.log("Resolving route:", to)
    const result = originalResolve.call(this, to, currentLocation)
    console.log("Route resolved successfully:", result.name)
    return result
  } catch (error) {
    console.error("Router resolve error for:", to, error)
    throw error
  }
}*/

const { handleRedirect } = useAuth()

router.beforeEach(async (to, from, next) => {
  try {
    await handleRedirect()
    next()
  } catch (error) {
    console.error("Router guard: Error handling redirect promise:", error)
    next()
  }
})

export default router
